import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from "@angular/core";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getAuth, provideAuth } from "@angular/fire/auth";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { environment } from "@env/environment";
import { provideQueryClient } from "@ngneat/query";
import { QueryClient } from "@tanstack/query-core";
import { routes } from "./app.routes";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { correlationInterceptor } from "./core/interceptors/correlation.interceptor";
import { errorInterceptor } from "./core/interceptors/error.interceptor";
import * as Sentry from "@sentry/angular";

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.isDev ? 'development' : 'production',
    tracesSampleRate: 0.1,
    beforeSend(event) {
      if (environment.isDev) {
        return null;
      }
      return event;
    },
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        correlationInterceptor,
        authInterceptor,
        errorInterceptor,
      ]),
    ),
    provideRouter(routes),
    provideAnimations(),
    provideQueryClient(
      () =>
        new QueryClient({
          defaultOptions: {
            queries: {
              staleTime: 1000 * 60 * 2,
            },
          },
        }),
    ),
    provideFirebaseApp(() => initializeApp(environment.firebaseKeys)),
    provideAuth(() => getAuth()),
      ],
};
